import { Address } from 'viem';

import { Vault } from '@/features/vaults/types';
import { tBtcTokenAddress } from '@/features/vaults/constants/vaults/mezo/tokens/tBtcTokenAddress';
import { wBtcTokenAddress } from '@/features/vaults/constants/vaults/mezo/tokens/wBtcTokenAddress';

export const mezoBtcPreDepositVaultId = 'mezo-btc-pre-deposit-vault';

export const mezoBtcPreDepositVaultAddress: Address = '0xa8A3De0c5594A09d0cD4C8abc4e3AaB9BaE03F36';

export const mezoBtcPreDepositVault: Vault = {
  id: mezoBtcPreDepositVaultId,
  type: 'core-vault',
  category: 'core-vault',
  name: 'Mezo BTC Pre-Deposit Vault / deprecated',
  description:
    'Bring It Home to Mezo with Highest BTC Yield onchain this season. Curated Bitcoin yield vault by Sense.capital. Deposits are deployed into onchain liquidity strategies like Mezo Tigris, Uniswap V4, Curve and Yield Basis.\n' +
    '<br /><br />' +
    'Curator: Sense Capital — Quantitative fund specializing in institutional-grade DeFi strategies. Focus on IL-minimized, full-reserve, diversified yield across blue-chip venues',
  address: mezoBtcPreDepositVaultAddress,
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: mezoBtcPreDepositVaultAddress,
    },
  ],
  curators: ['mezo', 'sense'],
  operator: [],
  baseToken: tBtcTokenAddress,
  depositTokens: [
    {
      address: tBtcTokenAddress,
      decimals: 18,
      symbol: 'tBTC',
    },
    {
      address: wBtcTokenAddress,
      decimals: 18,
      symbol: 'WBTC',
    },
  ],
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  lpTokenSymbol: 'mbhBTC',
  lpTokenDecimals: 18,
  allocations: {
    showAllocationsTab: true,
  },
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  isWithdrawDisabled: true,
  isInstantDeposit: true,
  predictedApy: {
    value: 35,
    type: 'APY',
  },
  archived: true,
  deposit: {
    disabled: true,
  },
};
